

import React, { Component } from 'react';


class SelectKlassePartiListOption extends Component {

    render() {
        const { klasseParti, showDeltPaaOevelseInfo} = this.props;
        const partiId = klasseParti.partiId;
        let dommer = klasseParti.dommerNavn1;
        if (dommer === null) {
            dommer = klasseParti.dommerNavn2;
        }
        if (dommer === null) {
            dommer = klasseParti.dommerNavn3;
        }
        if (dommer === null) {
            dommer = klasseParti.dommerNavn4;
        }
        let label = klasseParti.klasse.klasseNavn + ", dag " + klasseParti.dag;

        if (showDeltPaaOevelseInfo !== null && showDeltPaaOevelseInfo && klasseParti.klasse.deltPaaOevelser) {
            label += ", øvelser " +
                klasseParti.klasse.fraOevelse + " - " + klasseParti.klasse.tilOevelse;
        }
        if (dommer !== null && dommer !== '') {
            label += " - " + dommer;
        }
        if (showDeltPaaOevelseInfo !== null && showDeltPaaOevelseInfo && klasseParti.klasse.deltPaaOevelser && klasseParti.hovedparti) {
            label += " (Hovedhold)";
        }

        return (
            <option value={partiId}>{label}</option>
        );
    }
}
export default SelectKlassePartiListOption;











// WEBPACK FOOTER //
// ./src/SelectKlassePartiListOption.js